/* global globals */
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import MemberStore from '../stores/MemberStore';

const { ActionTypes } = Constants;

const requestApi = function requestApi(data, pathUrl, full) {
  const path = (pathUrl[0] === '/') ? pathUrl.substr(1) : pathUrl;

  let url = _.get(globals, 'apiWebroot', '/') + path;

  // TODO šo aspektu vēl apskatīt
  if (full) {
    url = _.get(globals, 'webroot', '/') + path;
  }

  if (data !== null) {
    let params = '';
    for (const key in data) { // eslint-disable-line no-restricted-syntax
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (params !== '' || path.indexOf('?') !== -1) {
          params += '&';
        }
        params += key + '=' + encodeURIComponent(data[key]); // eslint-disable-line prefer-template
      }
    }

    if (path.indexOf('?') === -1) {
      url += '?';
    }

    url += params; // eslint-disable-line prefer-template
  }

  return fetch(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });
};

// Uztaisīts, lai var aizvākt page no url, kad tas tiek padots atsevišķi
// Ja to neaizvāc, tad ir divi page parametri
// Var izmantot arī, lai noņemtu citus parametrus, ja nepieciešams
const removeParam = function removeParams(url, param) {
  const questionMark = '?';
  const splitUrl = url.split(questionMark);
  if (!splitUrl[1]) {
    return url;
  }

  const params = splitUrl[1].split('&');
  for (let i = 0; i < params.length; i += 1) {
    if (params[i].indexOf(param) > -1) {
      params.splice(i, 1);
      break;
    }
  }

  return splitUrl[0] + questionMark + params.join('&');
};

module.exports = {
  // Bloķēt lietotāju
  block(memberId) {
    const request = requestApi(null, `member/${memberId}/block.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      const status = _.get(data, 'status', '');
      const canAccess = _.get(data, 'canAccess', null);
      const blocked = _.get(data, 'blocked', null);
      //
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_BLOCK,
        memberId,
        canAccess,
        success: (status === 'ok' && blocked),
      });
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_BLOCK,
        memberId,
        success: false,
      });
    });
  },
  // Atbloķēt lietotāju
  unblock(memberId) {
    const request = requestApi(null, `member/${memberId}/unblock.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      const status = _.get(data, 'status', '');
      const canAccess = _.get(data, 'canAccess', null);
      const blocked = _.get(data, 'blocked', null);
      //
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_UNBLOCK,
        memberId,
        canAccess,
        success: (status === 'ok' && (typeof blocked === 'boolean') && !blocked),
      });
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_UNBLOCK,
        memberId,
        success: false,
      });
    });
  },
  // Ignorē lietotāju
  ignore(memberId) {
    const request = requestApi(null, `member/${memberId}/ignore.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_IGNORE,
        memberId,
        success: (_.get(data, 'status', '') === 'ok'),
      });
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_IGNORE,
        memberId,
        success: false,
      });
    });
  },
  // atceļ lietotāja ignorēšanu
  unignore(memberId) {
    const request = requestApi(null, `member/${memberId}/unignore.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_UNIGNORE,
        memberId,
        success: (_.get(data, 'status', '') === 'ok'),
      });
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBER_UNIGNORE,
        memberId,
        success: false,
      });
    });
  },
  // Favoritē lietotāju
  addfavorite(memberId) {
    const request = requestApi(null, `member/${memberId}/add_to_favorites.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      console.log('add_to_favorites:');
      console.log(data);
    }).catch((data) => {
      console.log(data);
      // window.location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Favoritē lietotāju
  removefavorite(memberId) {
    const request = requestApi(null, `member/${memberId}/remove_from_favorites.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      console.log('remove_from_favorites:');
      console.log(data);
    }).catch((data) => {
      console.log(data);
      // window.location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // piemiedz ar aci lietotājam
  wink(memberId) {
    const request = requestApi(null, `member/${memberId}/wink.json`, true);

    // success
    request.then((resp) => resp.json()).then((data) => {
      console.log('wink:');
      console.log(data);
    }).catch((data) => {
      console.log(data);
      // window.location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Sūtīt vai nesūtīt vēstules, ja nospiests Enter
  submitOnEnter(value) {
    // console.log(value);
    const request = requestApi({ value }, 'member/submit_on_enter');
    console.log(request);

    AppDispatcher.dispatch({
      type: ActionTypes.SUBMIT_ON_ENTER,
      value,
    });
  },
  loadLocalSearchedMembers() {
    if (typeof globals.searched_members_data === 'undefined') {
      return;
    }

    const page = _.get(globals, 'searched_members_data.page', false);

    AppDispatcher.dispatch({
      type: ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS,
      members: globals.searched_members_data.members,
      page,
    });
  },
  loadSearchedMembers(page, url = 'search', previous = false) {
    requestApi({ page }, url).then((resp) => resp.json()).then((data) => {
      // pievieno lietotāja datus
      if (!_.isEmpty(data.status) && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS,
          members: data.members,
          page: data.page,
          previous,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.SEARCHED_MEMBERS_LOAD_FAIL,
      });
    });
  },
  loadLocalFetchedMembers(memberIds, page, paginationUrl) {
    if (typeof globals.fetched_members_data === 'undefined') {
      if (memberIds.length > 0) {
        try {
          this.loadFetchedMembers(1, memberIds, 'member/fetch_members');
        } catch (e) {
          console.log(e);
        }
      } else {
        let $url = window.location.pathname;

        if (typeof paginationUrl !== 'undefined') {
          $url = paginationUrl;
        }

        this.loadFetchedMembers(page, null, `${$url}${window.location.search}`);
      }
    } else {
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBERS_LOAD_SUCCESS,
        members: globals.fetched_members_data.members,
        page: globals.fetched_members_data.page,
      });
    }
  },
  loadFetchedMembers(page, memberIds, path, nextPage = false) {
    let pathUrl = path;
    if (typeof pathUrl === 'undefined' || pathUrl === null) {
      pathUrl = 'search';
    }

    const self = this;

    const requestData = {};
    if (memberIds) {
      requestData.member_ids = memberIds;
    }
    if (page) {
      if (pathUrl.indexOf('page')) {
        pathUrl = removeParam(pathUrl, 'page');
      }
      requestData.page = page;
    }

    const request = requestApi(requestData, pathUrl);

    // success
    request.then((resp) => resp.json()).then((data) => {
      // pievieno lietotāja datus
      if (!_.isEmpty(data.status) && data.status === 'ok') {
        //
        if (typeof data.minMemberCount !== 'undefined'
          && typeof data.section !== 'undefined'
          && MemberStore.getBiggestActivePage(data.section) <= 5
        ) {
          // This is not precise number, can be for example 5.05, when minMemberCount is 101
          // Intended to be used to check if there are at least 5 full pages,
          // and if not, then how many are there
          const pages = data.minMemberCount / 20;
          //
          if (pages > 5) {
            MemberStore.setBiggestActivePage(5, data.section);
            MemberStore.setMorePages(true, data.section);
            MemberStore.setTotalItemsCount(null, data.section);
          } else {
            MemberStore.setBiggestActivePage(Math.ceil(pages), data.section);
            MemberStore.setMorePages(false, data.section);
            MemberStore.setTotalItemsCount(data.minMemberCount, data.section);
          }
        }

        if (nextPage === false) {
          AppDispatcher.dispatch({
            type: ActionTypes.MEMBERS_FETCH_SUCCESS,
            members: data.members,
            page: data.page,
          });
          // Lādē nākamo lapu tikai tad, ja nav norādīts, ka to nevajag darīt,
          // un, ja jau nav ielādēti lietotāji šai lapai
          if (MemberStore.getLoadNextPage() && !MemberStore.getFetchedMemberPage(page + 1)) {
            self.loadFetchedMembers(page + 1, null, path, true);
          }
        } else {
          AppDispatcher.dispatch({
            type: ActionTypes.MEMBERS_FETCH_NEXT_PAGE_SUCCESS,
            members: data.members,
            page: data.page,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
      if (nextPage === false) {
        AppDispatcher.dispatch({
          type: ActionTypes.MEMBERS_FETCH_FAIL,
        });
      }
    });
  },
  loadFetchedMembersPage(page, url) {
    AppDispatcher.dispatch({
      type: ActionTypes.MEMBERS_FETCH_LOADED_PAGE,
      page,
    });
    // Lādē nākamo lapu tikai tad, ja nav norādīts, ka to nevajag darīt,
    // un, ja jau nav ielādēti lietotāji šai lapai
    if (MemberStore.getLoadNextPage() && !MemberStore.getFetchedMemberPage(page + 1)) {
      this.loadFetchedMembers(page + 1, null, url, true); // nākamās lapas datus ielādēt
    }
  },
  getSearchableQuestions(questionsData, additionalQuestionsData) {
    if (typeof questionsData !== 'undefined' && typeof additionalQuestionsData !== 'undefined') {
      AppDispatcher.dispatch({
        type: ActionTypes.QUESTIONS_FETCH_SUCCESS,
        questions: questionsData,
        additionalQuestions: additionalQuestionsData,
      });

      return;
    }

    const requestData = {};
    const request = requestApi(requestData, 'questions/searchable.json', true);

    request.then((resp) => resp.json()).then((data) => {
      if (
        data.status === 'ok'
      ) {
        const questions = _.get(data, 'questions', []);
        const additionalQuestions = _.get(data, 'additional_questions', []);

        AppDispatcher.dispatch({
          type: ActionTypes.QUESTIONS_FETCH_SUCCESS,
          questions,
          additionalQuestions,
        });
      }
    });
  },
};
